const AUTH_ENDPOINT = {
    LOGIN: "auth/login/:tenant_name",
}

export default AUTH_ENDPOINT;